import { getSafeSupabaseClient } from '../supabaseSync';
import { unwrapRpcResult } from './rpcEnvelope';

export interface AnswerInquiryArgs {
  inquiryId: string;
  answer: string;
  actorId: string;
  actorName?: string | null;
}

export interface AnswerInquiryResult {
  success: boolean;
  inquiry_id: string;
  loop_id: string;
  status: 'ANSWERED';
}

/**
 * Answer an inquiry.
 * 
 * Atomic transaction:
 * - Updates inquiry status to ANSWERED
 * - Emits governance event (inquiry_answered)
 */
export async function answerInquiry(args: AnswerInquiryArgs): Promise<AnswerInquiryResult> {
  const supabase = getSafeSupabaseClient();
  if (!supabase) {
    throw new Error('Supabase client not available');
  }

  if (!args.answer || args.answer.trim() === '') {
    throw new Error('Inquiry answer is required');
  }

  const { data, error } = await supabase.rpc('catchball_answer_inquiry', {
    p_inquiry_id: args.inquiryId,
    p_answer: args.answer,
    p_actor_id: args.actorId,
    p_actor_name: args.actorName ?? null,
  });

  // Refusals arrive either as a PostgREST error or as { success: false, error }.
  return unwrapRpcResult<AnswerInquiryResult>(data, error, 'The server refused the answer.');
}
